<app-workflow-step-layout [readOnly]="readOnly">
  <ng-container info>
    <div>
      <h3>Verwendete Chargen bei Swab Platte</h3>

      <app-batches-selector
        [readOnly]="readOnly"
        [forms]="batchFormArray"
        (onChange)="validateStep()">
      </app-batches-selector>

      <div class="plate-swap-button">
        <!-- if the current step === DNA_EXTRACTION_SWAB show the next button here -->
        <core-button
          *ngIf="workflowDetailClientService.workflowInstance.currentStep !== WorkflowStep.DNA_EXTRACTION_SWAB_LYSIS"
          [text]="'Zur Swab Lysis Platte wechseln'"
          [backgroundColor]="'#607D8B'"
          (onClick)="switchPlateToSwabLysisView()">
        </core-button>

      </div>

    </div>
    <app-position-detail
      [position]="selectedPosition"
      [showChangeStateButton]="!readOnly"
      [showPipettingStatus]="true">
    </app-position-detail>

  </ng-container>
  <ng-container plate>
    <app-plate-view
      [plateMode]="PlateMode.PIP_STATUS"
      [workflowInstance]="workflowInstance"
      [plates]="workflowStep?.plates"
      (onPositionSelected)="onCellClick($event)"
      (onClearPositionSelected)="onCellClick(null)">
    </app-plate-view>
  </ng-container>
</app-workflow-step-layout>
